import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true
    }
  ],
  standalone: false
})
export class TextInputComponent implements ControlValueAccessor {

  @Input() value: string = '';
  @Output() valueChange: EventEmitter<string> = new EventEmitter();

  @Input() inputName!: string;
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() type?: string;
  @Input() required: boolean = true;
  @Input() readonly: boolean = false;
  @Input() rightIcon?: string;
  @Output() rightIconClicked: EventEmitter<any> = new EventEmitter();

  isFocused: boolean = false;

  validationMessage: string = '';

  @Input() control!: FormControl;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor() {}

  writeValue(value: any): void {
    // Avoid setting the value if it's the same, to prevent loops
    if (this.control && value !== this.control.value) {
      this.control.setValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.control.valueChanges.subscribe(value => {
      // this.onChange(value);
      this.valueChange.emit(value);
    });
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // isDisabled ? this.control.disable() : this.control.enable();
  }

  handleFocus() {
    this.isFocused = true;
    this.onTouched();
  }

  handleBlur() {
    this.isFocused = false;
  }

  handleRightIconClick() {
    this.rightIconClicked.emit();
  }
}